import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  Switch,
  Tooltip,
  Tag,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_LIST_STORE, API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_ENABLE_DISABLE_STORE } from "api/store-managemnt";
import { TbRefresh } from "react-icons/tb";
import userplace from "../../../assets/img/orders/orderDetail/userplace.png";

import { CONSTANTS } from "config/constant";
const { Column } = Table;
const { TextArea } = Input;
const StoreTables = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [deleteId, setDeleteId] = useState("");

  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_STORE(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_providers }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/store-management/edit/${record._id}`, {
      state: { data: record },
    });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/store-management/${record._id}`, {
      state: { data: record },
    });
  };

  const handleDelete = async (id) => {
    try {
      await API_DELETE_STORE(id);
      message.success("Store deleted successfully");
      setEditModalVisible(false);

      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting store:", error);
      message.error("Failed to delete store");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };
  const handleSwitchChange = async (checked, record) => {
    try {
      const response = await API_ENABLE_DISABLE_STORE(record._id);
      message.success(response?.message);
      fetchData();
    } catch (error) {
      console.error("Error toggling store status:", error);
      message.error("Failed to toggle store status");
    }
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  return (
    <div>
      <div className=" mb-4 flex justify-between">
        <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        />
        <div className="flex items-center gap-4">
          <TbRefresh className="h-8 w-8 cursor-pointer" onClick={fetchData} />

          <Link
            to={"/admin/store-management/create-store"}
            className="linear p-[4px 11px] flex w-full max-w-[10rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
          >
            {/* + Create Store */}+ {t("Create Store")}
          </Link>
        </div>
      </div>
      <Table
        dataSource={data?.providers}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id} // Assuming each record has a unique id
        rowClassName={getRowClassName} // Apply alternating row colors
        scroll={{ x: true }}
      >

        <Column
          title={t("Profile Picture")}
          dataIndex="profile_image"
          key="profile_image"
          render={(text, record) => (
            <span>
              {
                <img
                  src={
                    record?.profile_image?.[0]?.file_url
                      ? CONSTANTS?.IMG_DIRECTORY +
                        record?.profile_image?.[0]?.file_url
                      : userplace
                  }
                  style={{
                    width: "4rem",
                    height: "4rem",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                  alt=""
                />
              }
            </span>
          )}
          width="9rem"
        />
        <Column
          title={t("Store Title")}
          dataIndex="store_name"
          key="store_name"
          width="9rem"
        />
        <Column
          title={t("Store Description")}
          dataIndex="description"
          key="description"
          width="9rem"
          render={(text, record) => (
            <Tooltip title={record?.description}>
              {record?.description?.length > 20
                ? `${record?.description.substring(0, 20)}...`
                : record?.description}
            </Tooltip>
          )}
        />
        <Column
          title={t("Store owner")}
          key="store_owner_info "
          render={(text, record) => (
            <span>
              {record?.store_owner_info?.[0]?.first_name +
                " " +
                record?.store_owner_info?.[0]?.last_name}
            </span>
          )}
          width="9rem"
        />
        <Column
          title={t("Description")}
          dataIndex="description"
          key="description"
          width="9rem"
          render={(text, record) => (
            <Tooltip title={record?.description}>
              {record?.description?.length > 20
                ? `${record?.description.substring(0, 20)}...`
                : record?.description}
            </Tooltip>
          )}
        />
        <Column
          title={t("Store Location")}
          dataIndex="location"
          key="location"
          width="9rem"
          // render={(text, record) => <span>{record?.location?.address}</span>}
          render={(text, record) => (
            <Tooltip title={record?.address}>
              {console.log(record?.address, "iamadafdsfadsfasd")}
              {record?.address?.length > 20
                ? `${record?.address?.substring(0, 20)}...`
                : record?.address}
            </Tooltip>
          )}
        />
        <Column
          title={t("Current Status")}
          dataIndex="is_open"
          key="is_open"
          width="9rem"
          render={(text, record) =>
            record?.is_open == false ? (
              <Tag color="red">{t("Closed")}</Tag>
            ) : (
              <Tag color="red">{t("Open")}</Tag>
            )
          }
        />
        <Column
          title={t("Status")}
          dataIndex="is_disable"
          key="is_disable"
          width="9rem"
          render={(text, record) => (
            <Switch
              checked={!record?.is_disable}
              onChange={(checked) => handleSwitchChange(checked, record)}
            />
          )}
        />

        {/* <Column
          title="Select Laundry"
          dataIndex="laundry"
          key="laundry"
          render={(text, record) => <span>{record?.laundry?.[0]}</span>}
        /> */}
        <Column
          title={t("Actions")}
          key="actions"
          width="9rem"
          render={(text, record) => (
            <div>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              ></Button>
              <Popconfirm
                title={t("Are you sure to delete this store?")}
                // onConfirm={() => handleDelete(record?._id)}
                onConfirm={() => {
                  if (record?.orders_count > 0) {
                    setEditModalVisible(true);
                    setDeleteId(record?._id);
                  } else {
                    handleDelete(record?._id);
                  }
                }}
                okText={t("Yes")}
                cancelText={t("No")}
              >
                <Button
                  type="danger"
                  icon={<DeleteOutlined />}
                  style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                ></Button>
              </Popconfirm>
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
            </div>
          )}
        />
      </Table>

      {/* Edit Store Modal */}
      {/* <Modal
        key={selectedStore?._id}
        // title={t("Edit Store")}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "65rem" }}
      >
        <EditStore data={selectedStore} />
      </Modal> */}
      <Modal
        key={selectedStore?._id}
        className="modal-store"
        // title={t("Edit Catagory")}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        centered
        // style={{ minWidth: "65rem" }}
      >
        All orders and data under this store will also be deleted. Are you sure
        you want to delete?
        <div className="flex">
          <Button
            className="btn-gradient   mx-auto mt-4  flex w-40 p-5 text-[white]"
            onClick={() => handleDelete(deleteId)}
          >
            Yess
          </Button>

          <Button
            className="btn-gradient   mx-auto mt-4  flex w-40 p-5 text-[white]"
            onClick={() => {
              setEditModalVisible(false);
            }}
          >
            No
          </Button>
        </div>
        {/* <EditCatagory data={selectedStore} /> */}
      </Modal>
      {/* View Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("View Store")}
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "60rem" }}
      >
        <ViewStore data={selectedStore} />
      </Modal>
    </div>
  );
};

export default StoreTables;
